<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Marcador de consumo alimentar - Inconsistências"
    >
        <template v-if="data">
            <rkm-area
                title="Paciente"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Nome"
                            :value="data.paciente.campos.nomeCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.paciente.campos.cnsCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CPF"
                            :value="data.paciente.campos.cpfCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Data de nascimento"
                            :value="data.paciente.campos.dataNascimento"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Sexo"
                            :value="data.paciente.campos.sexo"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.paciente.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Profissional responsável"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Nome"
                            :value="data.profissional.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissional.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissional.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissional.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="INE"
                            :value="data.profissional.campos.ine"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissional.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Data"
                            :value="data.profissional.campos.dataAtendimento"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Local de atendimento"
                            :value="data.profissional.campos.localAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissional.inconsistencias" />
            </rkm-area>

            <rkm-area
                :title="data.questionario.titulo"
                type="fieldset"
            >
                <rkm-table
                    v-if="perguntasGerais.length > 0"
                    hide-filters
                    hide-pagination
                    :items="perguntasGerais"
                    :fields="[
                        { key: 'pergunta', label: 'Pergunta' },
                        { key: 'respostas', label: 'Resposta', formatter: r => r.join(', ') },
                    ]"
                />

                <rkm-area
                    v-if="perguntasConsumo.length > 0"
                    :title="data.questionario.tituloConsumiu"
                >
                    <rkm-table
                        hide-filters
                        hide-pagination
                        :items="perguntasConsumo"
                        :fields="[
                            { key: 'pergunta', label: 'Pergunta' },
                            { key: 'respostas', label: 'Resposta', formatter: r => r.join(', ') },
                        ]"
                    />
                </rkm-area>

                <Inconsistencia :inconsistencias="data.questionario.inconsistencias" />
            </rkm-area>
        </template>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        perguntasGerais() {

            if (!this.data) {

                return []
            }

            return this.data.questionario.lista.filter(p => !p.areaOntemConsumiu)
        },
        perguntasConsumo() {

            if (!this.data) {

                return []
            }

            return this.data.questionario.lista.filter(p => p.areaOntemConsumiu)
        }
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error]
}
</script>